import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// Init Swiper with custom config for social media carousel
document.addEventListener('DOMContentLoaded', function () {
    const el = document.querySelector('.social-media__carousel');
    if (!el) return;

    new Swiper(el, {
        modules: [Navigation],
        slidesPerView: 2.5,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 6.5,
            },
            768: {
                slidesPerView: 2.5
            }
        },
    });
});
